// extracted by mini-css-extract-plugin
export default {"container":"DataView_container__ocWRx"};